import { render, staticRenderFns } from "./SalesComparisonTable.vue?vue&type=template&id=66bec255&scoped=true"
import script from "./SalesComparisonTable.vue?vue&type=script&lang=js"
export * from "./SalesComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./SalesComparisonTable.vue?vue&type=style&index=0&id=66bec255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bec255",
  null
  
)

export default component.exports